<template>
    <avatar :shape="shape" :title="title" :size='size' :src="userobj.header" :icon="localicon"
            :style="{backgroundColor:color,color:'#fff',cursor:'default',lineHeight:size+'px'}">
        {{ showname }}
    </avatar>
</template>

<script>

import $khttp from "@/kabala/js/khttp";
import $kuser from "@/kabala/js/kuser";
import $kspace from "@/kabala/js/kspace";
import $kutil from "@/kabala/js/kutil";
import avatar from './kabala-avatar';

export default {
    name: "kabala-userheader",
    props: ["user", "size", "shape", "icon"],

    components: {avatar},
    data: function () {
        return {
            localicon: '',
            localsize: '',
            userobj: {},//用户对象应包含：真实姓名、登录帐号、头像等信息
            showname: "",
            title: "",
            color: "",
            // colorList: ['#CC9999', '#FFFF99', '#666699', '#FF9900', '#FFFF00', '#0099CC', '#CCCC99', '#CC3399', '#99CC00', '#FF6666', '#FFFF00', '#3399CC']
            colorList: ['#889EFE', '#3396F8', '#51A6E2', '#4ED2C3', '#84D057', '#FEA003', '#F87E06', '#F15757']
        }
    },
    methods: {
        init: function () {
            // console.log('用户头像',this.user)
            this.localicon = this.icon;
            this.localsize = this.size;
            if (this.user === undefined) {
                let session  = $khttp.session();
                let useritem = $kuser.getuser(session.userid);
                if (useritem != null) {
                    this.userobj = useritem;
                } else {
                    this.userobj.uid = this.user;
                }

            } else if ((typeof this.user) == "string") {
                let useritem = $kuser.getuser(this.user);
                if (useritem != null) {
                    this.userobj = useritem;
                } else {//用户不存在，已被删除...
                    useritem = $kuser.getorg(this.user);
                    if (useritem != null) {
                        this.userobj = useritem;
                    } else {
                        if (!this.localicon) {
                            this.localicon = "warn-o";
                            this.showname  = '已删除';
                        }
                    }
                }
            } else {
                this.userobj = this.user;
            }
            if (this.userobj === undefined) {
                this.userobj = {};
            }
            if (this.userobj.uid === undefined) {
                this.userobj.uid = "";
                this.localicon   = "user-circle-o";
            }
            this.initUser(); // 初始化用户头像及名字
            if (!this.localsize) {
                this.localsize = "small";
            }
        },
        initUser: function () {

            if ($kutil.isArray(this.userobj)) {
                this.userobj = this.userobj[0];
            }
            if (!Object.prototype.hasOwnProperty.call(this.userobj, "header")) {
                this.userobj.header = "";
            }
            //如果外面指定了，则使用外部的
            if (Object.prototype.hasOwnProperty.call(this.userobj, "icon")) {
                this.localicon = this.userobj.icon;
            }
            //如果外部指定了，则使用外部的
            if (this.userobj.color) {
                this.color = this.userobj.color;
            }
            //如果指定了name属性并且没有制定真实名字则赋值
            if (Object.prototype.hasOwnProperty.call(this.userobj, "name")) {
                if ($kuser.isuser(this.userobj.uid)) {
                    //获取缓存整体对象
                    let userheadercache    = function (uid, url) {
                        var localUserHeader = window.localStorage.getItem("kabala.userheader");
                        if (localUserHeader !== undefined && localUserHeader !== null && localUserHeader.length > 0) {
                            return JSON.parse(localUserHeader);
                        } else {
                            return {};
                        }
                    };
                    let userheadercacheset = function (uid, url) {
                        var cache = userheadercache();
                        delete cache[uid];
                        delete cache[uid + ".expiretime"];
                        cache[uid]                 = url;
                        cache[uid + ".expiretime"] = new Date().getTime() + 1 * 60 * 60 * 1000;
                        window.localStorage.setItem("kabala.userheader", JSON.stringify(cache));
                    };
                    let userheadercacheget = function (uid) {
                        if (uid === undefined || uid === null)
                            return "";
                        var obj = userheadercache();
                        if (Object.prototype.hasOwnProperty.call(obj, uid)) { //如果存在头像...
                            var url = obj[uid];
                            //检查头像是否过期...
                            if (Object.prototype.hasOwnProperty.call(obj, uid + ".expiretime")) {
                                var expiretime = obj[uid + ".expiretime"];
                                if (new Date().getTime() > expiretime) {
                                    return "";
                                } else {
                                    return url;
                                }
                            }
                        }
                    };
                    try {
                        let that      = this;
                        var sysspace  = $kutil.getspacebytype("systemspace").spaceroot;
                        var serverimg = sysspace + "/user/header/" + this.userobj.uid;
                        var url       = userheadercacheget(this.userobj.uid);	//服务器重启之后可能头像就不生效了...
                        if (url !== undefined && url !== null && url.length > 0 && url !== 'nosetting') { //未设置等情况
                            this.userobj.header = url;
                            this.color          = "";
                            this.localicon      = "";
                            return;
                        }
                        if (url !== 'nosetting') {
                            $kspace.askdownload(serverimg, "", "", "image/jpeg", 86400, null).then(function (download) {
                                if (download.url !== undefined && download.url != null && download.url.length > 0) {
                                    userheadercacheset(that.userobj.uid, download.url);
                                    that.userobj.header = download.url;
                                    that.color          = "";
                                    that.localicon      = "";
                                }
                            }).catch(function (err) {
                                //可能不存在..
                                userheadercacheset(that.userobj.uid, "nosetting");
                            });
                        }
                    } catch (e) {
                        console.log(e);
                    }
                    var chinaReg   = /[\u4e00-\u9fa5]/g;
                    var formatname = this.userobj.name.replace(/[^\u4e00-\u9fa5]/gi, "");
                    var enName = this.userobj.name.replace(/^[A-Za-z]$/gi,"")

                    if (formatname !== undefined && formatname != null && formatname.length > 0) {
                        this.localicon = '';
                        this.color     = this.colorList[formatname.substring(0, 1).charCodeAt() % this.colorList.length];
                        var c          = formatname.substring(0, 1);
                        this.showname  = formatname.substring(formatname.length - 1);
                        this.title     = formatname;

                        var reg = /^[A-Za-z0-9]+$/;
                        if (reg.test(chinaReg)) {
                            if (formatname.length > 2) {
                                this.showname = formatname.substring(0, 2);
                            } else {
                                this.showname = formatname;
                            }
                        }
                        return;
                    }

                    if(enName !== undefined && enName != null && enName.length > 0){
                        this.localicon = '';
                        this.color     = this.colorList[enName.substring(0, 1).charCodeAt() % this.colorList.length];
                        this.showname  = enName.substring(0, 2);
                        this.title     = enName;
                        return
                    }

                }

            }
            this.title    = this.userobj.uid;
            this.showname = "";
            this.color    = this.colorList[this.userobj.uid.substring(0, 1).charCodeAt() % this.colorList.length];
            if (!this.localicon) {
                this.localicon = "user-circle-o user";
            }
            if (this.userobj.header === undefined || this.userobj.header === null || this.userobj.header.length <= 0) {
                if (!this.localicon) {
                    this.localicon = "user-circle-o user";
                }
                if(this.userobj.type == '2'){
                    this.localicon = "k k-team group";
                    this.color = '#519AD4'
                }
            }
            if ($kuser.isorg(this.userobj.uid)) {
                this.showname = '部门';
            } else if ($kuser.isrole(this.userobj.uid)) {
                this.showname = '角色';
            }

        }
    },
    created: function () {
        this.init()
    },
    watch: {
        user: {
            deep: true,
            handler: function () {
                this.init()
            }
        }
    }
}
</script>

<style scoped>
</style>
